import MuiTabs, { type TabsProps } from "@mui/material/Tabs";
import MuiTab, { type TabProps } from "@mui/material/Tab";

export type { TabsProps, TabProps };

export function Tabs(props: TabsProps) {
  return <MuiTabs {...props} />;
}

export function Tab(props: TabProps) {
  return <MuiTab {...props} />;
}
